import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_GENERAL_CANCELAR, ESTILO_INPUT_GENERICO } from "../../../utils/const-estilos";
import { crearCategoria, modificarCategoria } from "../../../api/checklist";
import "../../../style/style-cargando.css";
import { obtenerListaTipoIncidente } from "../../../api/tipo-incidente";
import Select from "react-select";

export default function Categoria() {
  const location = useLocation();
  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [opcionRespuesta, setOpcionRespuesta] = useState(null);
  const [titulo, setTitulo] = useState("");

  const [listaTipoIncidente, setListaTipoIncidente] = useState([]);
  const [tipoIncidenteSelected, setTipoIncidenteSelected] = useState(null);

  useEffect(() => {
    // console.log("entro a Correos");
    iniciar();
  }, []);

  const iniciar = () => {
    try {
      const data = location.state;
      console.log("data");
      console.log(data);
      if (data !== undefined && data !== null) {
        setOpcionRespuesta(data.params);
        setTitulo(data.titulo);
      }
      cargarInfoExtra(data.params);
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  }

  const cargarInfoExtra = async (params) => {
    try {
      // console.log('cargarInfoExtra');
      // console.log(params);
      const listaIncidente = await obtenerListaTipoIncidente();
      let arr = [];
      // console.log('listaIncidente');
      // console.log(listaIncidente);
      for (let i = 0; i < listaIncidente.length; i++) {
        const element = listaIncidente[i];
        let obj = {};
        obj.value = element.id;
        obj.label = element.descripcion;
        arr.push(obj);
      }
      // console.log('arr');
      // console.log(arr);
      // console.log('listaIncidente');
      // console.log(listaIncidente);
      setListaTipoIncidente(arr);
      if (params.idTipoIncidente !== undefined && params.idTipoIncidente !== null) {
        let tipoIncidente = listaIncidente.find(e => e.id === params.idTipoIncidente);
        // console.log('tipoIncidente');
        // console.log(tipoIncidente);
        tipoIncidente.value = tipoIncidente.id;
        tipoIncidente.label = tipoIncidente.descripcion;
        setTipoIncidenteSelected(tipoIncidente);
      }
    } catch (err) {
      console.log("cargarInfoExtra err");
      console.log(err);
    }
  }

  const handleInputChange = (event) => {
    // console.log('handleInputChange');
    const { name, value } = event.target;
    // console.log(name);
    // console.log(value);
    setOpcionRespuesta({ ...opcionRespuesta, [name]: value });
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const handleSaveClick = async () => {
    // console.log('handleSaveClick');
    // lógica para guardar los cambios
    // console.log('correo');
    // console.log(correo);
    let objEnviar = {};
    objEnviar.descripcion = opcionRespuesta.descripcion;
    objEnviar.id = opcionRespuesta.id;
    if (tipoIncidenteSelected !== null) {
      objEnviar.idTipoIncidente = tipoIncidenteSelected.value;
    } else {
      objEnviar.idTipoIncidente = null;
    }
    if (opcionRespuesta.id <= 0) {
      // console.log('crear correo');
      let creado = await crearCategoria(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (creado === true) {
        alert('Se creo correctamente');
        handleCancelClick();
      }
      if (creado === false) {
        alert('No se pudo crear');
      }
    }
    if (opcionRespuesta.id > 0) {
      // console.log('actualizar correo');
      let modificado = await modificarCategoria(objEnviar);
      // console.log('modificado');
      // console.log(modificado);
      if (modificado === true) {
        alert('Se modifico correctamente');
        handleCancelClick();
      }
      if (modificado === false) {
        alert('No se pudo modificar');
      }
    }
  };

  const handleTipoIncidente = async (event) => {
    try {
      setTipoIncidenteSelected(event);
    } catch (err) {
      console.log('handleTipoIncidente err');
      console.log(err);
    }
  }

  const render = () => {
    // console.log('render correo');
    try {
      if (cargandoPage === true) {
        return (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginTop: 30,
            }}
          >
            <div className="loader"></div>
            <div
              style={{ marginTop: 10, }}
            >
              <p>Cargando...</p>
            </div>
          </div>
        );
      }
      if (cargandoPage === false && opcionRespuesta === null) {
        return (
          <div>
            <label> Sin data</label>
          </div>
        );
      }
      return (
        <div className="min-h-screen bg-gray-100 flex flex-col  py-12 sm:px-6 lg:px-8">
          <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <h2 className="text-center text-3xl font-extrabold text-gray-900">
              {titulo}
            </h2>
            <div className="mt-6 bg-white py-6 px-4 shadow-md rounded-lg sm:px-10">
              <div className="space-y-6">

                <label
                  htmlFor="nombre"
                  className="block text-sm font-medium text-gray-700"
                >
                  SELECCIONE TIPO INCIDENTE
                </label>
                <Select options={listaTipoIncidente}
                  isSearchable='true'
                  isClearable='true'
                  value={tipoIncidenteSelected}
                  onChange={(event) => handleTipoIncidente(event)}
                  placeholder='SELECCIONE TIPO INCIDENTE'
                />

                <div>
                  <label
                    htmlFor="nombre"
                    className="block text-sm font-medium text-gray-700"
                  >
                    CATEGORIA
                  </label>
                  <div className="mt-1">
                    <input
                      id="descripcion"
                      name="descripcion"
                      type="text"
                      value={opcionRespuesta.descripcion}
                      onChange={handleInputChange}
                      autoComplete="given-name"
                      className={ESTILO_INPUT_GENERICO}
                      required
                      maxLength={127}
                    />
                  </div>
                </div>

                <div className="flex justify-end">
                  <div
                    style={{
                      justifyContent: 'space-between',
                      display: 'flex',
                      width: '100%'
                    }}
                  >
                    <button
                      type="button"
                      className={ESTILO_BOTON_GENERAL_CANCELAR}
                      onClick={handleCancelClick}
                    >
                      Cancelar
                    </button>
                    <button
                      type="button"
                      className={ESTILO_BOTON_GENERAL_ACEPTAR}
                      onClick={handleSaveClick}
                    >
                      Aceptar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } catch (err) {
      console.log('Categoria render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
